<template>
    <div >
       <div class="w-full">
        <page-header
        :back="true"
        heading="Settings"
        breadcrumb=""
      />
       </div>
      
      <div class="flex justify-around flex-wrap items-center w-full mt-24">
      <div class="md:w-9/12 w-full flex justify-around mb-12 cursor-pointer"
      >
        <div    @click="$router.push('/settings/contact-information')" class="w-4/12 flex justify-center flex-wrap">
            <img src="@/assets/images/ondemand/account-profile.svg"/>
            <b class="block w-full text-center py-2">Account Profile</b>
            <p class="block w-full text-center">User profile and organization
                details.</p>
        </div>

        <div   @click="$router.push('/settings/account-security')" class="w-4/12 flex justify-center flex-wrap">
            <img src="@/assets/images/ondemand/security.svg"/>
            <b class="block w-full text-center py-2">Security</b>
            <p class="block w-full text-center">Security policies (passwords,
                2FA).</p>
        </div>
      </div>

     
      <div class="md:w-9/12 w-full flex justify-around cursor-pointer"
      >

        <div
        v-if="$_isDevelopment"
        @click="$router.push('/settings/payment')" class="w-4/12 flex justify-center flex-wrap">
            <img src="@/assets/images/ondemand/payment.svg"/>
            <b class="block w-full text-center py-2">Payments</b>
            <p class="block w-full text-center">Select and set up preferred payment
                methods for your shipments</p>
        </div>
      </div>


      </div>
    </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader.vue";

    export default {
        components: {
            PageHeader
        }
    }
</script>

<style lang="scss" scoped>

</style>